import { API_CONFIG, buildUrl } from '../config/apiConfig'
import type { 
  Pharmacy,
  PharmaciesQueryParams 
} from '../types/api'

export const pharmaciesApi = {
  // GET /pharmacies?type_503b=true
  async getPharmacies(params?: PharmaciesQueryParams): Promise<Pharmacy[]> {
    const url = buildUrl(API_CONFIG.PHARMACIES.LIST, params)
    const response = await fetch(url)
    
    if (!response.ok) {
      throw new Error(`Failed to fetch pharmacies: ${response.statusText}`)
    }
    
    return response.json()
  },
}